// src/pages/Files.js
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Breadcrumbs, BreadcrumbItem, useDisclosure } from "@nextui-org/react";
import LayoutSwitcher from "../components/switchers/LayoutSwitcher";
import { useSidebarStore } from "src/store/layout/useSidebarStore";
import SharedByGridList from "src/components/shared_files_layout/SharedByGridList";
import SharedByTableList from "src/components/shared_files_layout/SharedByTableList";
import DownloadList from "src/components/common/DownloadList";
import useFolderStore from "src/store/api/useFolderStore";
import { useNavigate } from "react-router-dom";
import { useSharedByFolderStore } from "src/components/shared_files/cards/SharedByMeFolderCard";
import useListSharedByFolderContents from "src/hooks/useListSharedByFolderContents";
import { useUserResources } from "src/hooks/useUserResourcesHooks";
import { Alert } from "antd";
import { useUploadFilesHooks } from "src/hooks/useUploadFilesHooks";
import CustomAlert from "src/components/common/CustomAlert";
import EmptyTrashModal from "src/components/modals/EmptyTrashModal";
import useListAllTrash from "src/hooks/useListAllTrash";
import useTrashFilesStore from "src/store/layout/useTrashFilesGridListStoreLayout";
import { useSharedFilesStore } from "src/store/layout/useSharedFilesStore";

const SharedByFiles = () => {
  const { t } = useTranslation();
  const { layout } = useSidebarStore();
  const { selectedFolderStack, popFolderByIndex, emptyFolderStack } = useFolderStore();
  const navigate = useNavigate();
  const { setFolderId, clearFolderId } = useSharedByFolderStore(); // Zustand store to manage selected folder id
  const { setTheSelectedFolderId, clearTheSelectedFolderId } = useListSharedByFolderContents();
  const { userResources, showStorageAlert } = useUserResources();
  const { errorExceelStorageMessage, setErrorExceelStorageMessage } = useSharedFilesStore();
  const { uploadResponseStatus } = useUploadFilesHooks(); // Use the custom hook
  const { isOpen: isEmptyTrashOpen, onOpen: onOpenEmptyTrashOpen, onClose: onCloseEmptyTrashOpen } = useDisclosure();
  const { listAllTrashedItems, totalItems } = useListAllTrash();
  const { rowsPerPage,page} = useTrashFilesStore();

  // Retrieve the last folder name if the stack is not empty
  const folderName =
    selectedFolderStack && selectedFolderStack.length > 0
      ? selectedFolderStack[selectedFolderStack.length - 1].folder_name
      : "";


  const handleBreadcrumbClick = (folder: any, index: number) => {
    setFolderId(folder.folder_id); // Set the folderId state
    setTheSelectedFolderId(folder.folder_id);
    popFolderByIndex(index);
    navigate("/sharedByFileList");
  };

  const handleMainBreadcrumbClick = () => {
    clearFolderId(); // Set the folderId state
    clearTheSelectedFolderId();
    emptyFolderStack();
    navigate("/Shared");
  };

  useEffect(() => {

    if (userResources?.can_upload ?? false)
      setErrorExceelStorageMessage(t('UsedStorage90Persent'));
    else
      setErrorExceelStorageMessage(t('ExceedAllowedStorage'));


    let folderId = useSharedByFolderStore.getState().folderId; // Fetching latest folderId
    const subfolderId = useFolderStore.getState().selectedFolderId;

    if (folderId === null && subfolderId === null) {
      navigate("/Shared");
    }
    listAllTrashedItems(page, rowsPerPage);

  }, [navigate, userResources, listAllTrashedItems]);


  return (
    <>
    {/* <Breadcrumbs isDisabled>
      <BreadcrumbItem>{t("SAFFCLOUD")}</BreadcrumbItem>
      <BreadcrumbItem>{t("Files")}</BreadcrumbItem>
    </Breadcrumbs> */}

    <Breadcrumbs>
      <BreadcrumbItem>
        <button onClick={() => handleMainBreadcrumbClick()} >
          {t("SharedByMe")}
        </button>
      </BreadcrumbItem>
      {selectedFolderStack?.map((folder, index) => (
        <BreadcrumbItem key={folder.folder_id}>
          <button onClick={() => handleBreadcrumbClick(folder, index)}>
            {folder.folder_name}
          </button>
        </BreadcrumbItem>
      ))}
    </Breadcrumbs>

    <div className="text-[33px] capitalize text-navy-700 mt-4 mb-5 flex justify-between">
      <div className="font-bold capitalize hover:text-navy-700">
        {folderName || t("Files")}
      </div>
      <LayoutSwitcher />
    </div>

    <div className="max-sm:hidden">
      <DownloadList />
    </div>
    {/* Alert Message */}
    {/* Alert Message */}
    {showStorageAlert && errorExceelStorageMessage && (
      <Alert
        className="bg-[#4b65bc2a] border-[#4b65bc2a] my-5 text-red-600 font-bold capitalize-first-letter"
        message={
          <span>
            {errorExceelStorageMessage}{" "}
            {totalItems > 0 && (
              <a
                href="#"
                onClick={() => {
                  // Logic to open an empty modal or perform other actions
                  onOpenEmptyTrashOpen();
                }}
                className="text-blue-600 underline hover:text-blue-800"
              >
                {t("EmptyTrash")}
              </a>
            )}
          </span>
        }
      />
    )}

    {uploadResponseStatus && (uploadResponseStatus === "error" || uploadResponseStatus === "success") && (
      // {uploadResponseStatus && uploadResponseStatus === "success" && (
      <CustomAlert />
    )}

    {layout === "grid" ? <SharedByGridList /> : <div className="">
      <SharedByTableList />
    </div>}

    <EmptyTrashModal
      isOpen={isEmptyTrashOpen}
      onClose={onCloseEmptyTrashOpen}
    />
  </>
  );
};

export default SharedByFiles;